import PropTypes from 'prop-types';

const ReferencePropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
]);

export default ReferencePropType;
